export default "__VITE_ASSET__ByyCycx6__"